/** The care pass: what a building does for each resident round by round, apart from medication.
 * The first three are scheduled slot by slot through the week; supervision is owed to every
 * resident on every shift and needs no schedule. */
export const CARE_PASS_ACTIONS = ["laundry", "room-cleaning", "bathing", "supervision"] as const;
export type CarePassAction = (typeof CARE_PASS_ACTIONS)[number];

export const CARE_PASS_ACTION_LABELS: Record<CarePassAction, string> = {
  laundry: "Laundry",
  "room-cleaning": "Room cleaning",
  bathing: "Bathing",
  supervision: "Supervision",
};

/** The actions a resident's week schedules; supervision is every shift's. */
export const SCHEDULED_CARE_PASS_ACTIONS = CARE_PASS_ACTIONS.filter(
  (action) => action !== "supervision",
);

export const CARE_PASS_OUTCOMES = ["done", "refused", "unavailable"] as const;
export type CarePassOutcome = (typeof CARE_PASS_OUTCOMES)[number];

export const CARE_PASS_OUTCOME_LABELS: Record<CarePassOutcome, string> = {
  done: "Done",
  refused: "Refused",
  unavailable: "Not available",
};
